import * as t from "io-ts";
import { Branding } from "./Branding";
import { ContactInfo } from "./ContactInfo";
import { Metadata } from "./Metadata";
import { Referral } from "./Referral";
import { Reward } from "./Reward";

export const Partner = t.intersection([
  t.type({
    contact_info: ContactInfo,
    rewards: t.array(Reward),
  }),
  t.partial({
    id: t.string,
    aid: t.string,
    oid: t.string,
    emails: t.array(t.string),
    branding: Branding,
    cids: t.array(t.string),
    referrals: t.array(Referral),
    current_reward: Reward,
    stats: t.partial({
      total_referrals: t.number,
      signups: t.number,
      subscribers: t.number,
      verifications: t.number,
      activations: t.number,
    }),
    metadata: Metadata,
  }),
]);

export interface Partner {
  id?: string;
  aid?: string;
  oid?: string;
  emails?: Array<string>;
  contact_info: ContactInfo;
  branding?: Branding;
  cids?: Array<string>;
  referrals?: Array<Referral>;
  rewards: Array<Reward>;
  current_reward?: Reward;
  stats?: {
    total_referrals?: number;
    signups?: number;
    subscribers?: number;
    verifications?: number;
    activations?: number;
  };
  metadata?: Metadata;
}
